import {AddressModel as AddressPickerData} from '../../../../components/forms/controls/addresspicker/addresspicker.component';
/**
 * Created by Rodrigo Quesada on 23/01/17.
 */

interface AddressData {
    address1?: string;
    postalCode?: string;
    city?: string;
    stateOrProvince?: string;
    country?: string;
}

export class AddressMapper {

    update(model: AddressData, addressPickerModel: AddressPickerData) {
        model.address1 = addressPickerModel.address1;
        model.postalCode = addressPickerModel.postalCode;
        model.city = addressPickerModel.city;
        model.stateOrProvince = addressPickerModel.stateOrProvince;
        model.country = addressPickerModel.country;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/common/mappers/address-mapper.class.ts